import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRecordContext, useRefresh } from "react-admin";
import { useUpdate } from "react-admin";
import IconButton from "@mui/material/IconButton";
import InstagramIcon from "@mui/icons-material/Instagram";

import { useIsOrderEditable } from "../components/DataHooks/useIsOrderEditable";
import { CONTACT_CHANNEL_INSTAGRAM } from "../components/Constant";
import {
  useContactFbProfile,
  useContactIgProfile,
  useUpdateContact,
} from "../components/DataHooks/useGetFbProfileImage";
import NewCustomerIcon from "../components/Contact/NewCustomerIcon";

const ContactLink = ({ source, label }) => {
  const record = useRecordContext();
  const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);
  const { contact = undefined } = record;
  const customerName = record[source];
  const isOutdated = contact && contact.name && contact.name !== customerName;
  const isOrderNamePsid = contact && customerName === contact.psid;

  const isContactNamePsid = contact && contact.psid === contact.name;
  const isOrderEditable = useIsOrderEditable();
  const shouldUpdate = (isOutdated || isOrderNamePsid) && isOrderEditable;

  const isInstagram = contact && contact.channel === CONTACT_CHANNEL_INSTAGRAM;
  const fbProfile = useContactFbProfile(
    !isInstagram && contact && contact.psid ? contact.psid : ""
  );

  const { data: igProfile, error: igProfileError } = useContactIgProfile(
    isInstagram && contact && contact.psid ? contact.psid : ""
  );

  const refresh = useRefresh();
  const [update, { isLoading, error }] = useUpdate();

  const { trigger } = useUpdateContact(
    contact && contact.id ? contact.id : "",
    {
      dedupingInterval: 15 * 60 * 1000,
      onSuccess: () => {
        refresh();
      },
    }
  );

  useEffect(() => {
    //update FB user contact
    if (
      shouldUpdate &&
      fbProfile &&
      fbProfile.name &&
      fbProfile.name.toLowerCase() !== "facebook user" &&
      (!customerName ||
        (contact && contact.id && contact.name !== fbProfile.name))
    ) {
      trigger({ profilePic: fbProfile.profile_pic, name: fbProfile.name });
    }
  }, [contact, customerName, fbProfile, trigger, shouldUpdate]);

  useEffect(() => {
    //update IG user contact
    if (
      igProfile &&
      igProfile.username &&
      (!customerName ||
        (contact && contact.id && contact.name !== igProfile.username))
    ) {
      trigger({ profilePic: igProfile.profile_pic, name: igProfile.username });
    }
  }, [contact, customerName, igProfile, trigger]);

  useEffect(() => {
    if (
      shouldUpdate &&
      !!fbProfile &&
      !isUpdatingOrder &&
      !isLoading &&
      !error
    ) {
      if (contact) {
        setIsUpdatingOrder(true);
        update("orders", {
          id: record.id,
          data: { customerName: fbProfile.name },
          previousData: { record },
        });
      }
    }
  }, [
    fbProfile,
    contact,
    error,
    isLoading,
    isUpdatingOrder,
    record,
    shouldUpdate,
    update,
  ]);

  useEffect(() => {
    if (
      shouldUpdate &&
      !!igProfile &&
      igProfile.username &&
      !isUpdatingOrder &&
      !isLoading &&
      !error
    ) {
      if (contact) {
        setIsUpdatingOrder(true);
        update("orders", {
          id: record.id,
          data: { customerName: igProfile.username },
          previousData: { record },
        });
      }
    }
  }, [
    igProfile,
    contact,
    error,
    isLoading,
    isUpdatingOrder,
    record,
    shouldUpdate,
    update,
  ]);

  return (
    <div>
      {contact ? (
        <div>
          <Link to={`/contacts/${contact._id}/show`}>{customerName}</Link>
          {contact && contact.createdAt && (
            <NewCustomerIcon createdAt={contact.createdAt} />
          )}
        </div>
      ) : (
        <span>{customerName}</span>
      )}
      {isInstagram && !isContactNamePsid && (
        <IconButton
          size="small"
          onClick={() => {
            window.open(`https://www.instagram.com/${contact.name}`, "_blank");
          }}
        >
          <InstagramIcon />
        </IconButton>
      )}
    </div>
  );
};

export default ContactLink;
